/* Cubold home: keep sold-out items out of the featured rows */
(function () {
  function hideSoldOut() {
    document.querySelectorAll('[id*="featured_collection"] li.grid__item, [id*="featured-collection"] li.grid__item').forEach(function (item) {
      var badge = item.querySelector('.badge');
      if (badge && /sold out/i.test(badge.textContent)) item.style.display = 'none';
    });
  }
  if (document.readyState !== 'loading') hideSoldOut();
  else document.addEventListener('DOMContentLoaded', hideSoldOut);
  window.addEventListener('load', hideSoldOut);
})();